export default "__VITE_ASSET__D$HAjRLH__"